<template lang="pug">
  Icon.icon(:name="iconName" v-if="type === 'icon'")
  div(v-else-if="type === 'title'")
    span(data-testid="notification-text") {{ text }}
    Link(v-if="route" :to="route" data-testid="notification-link")  Открыть
</template>

<script>
/**
 * Универсальный компонент уведомлений модуля «Спецификации и комплектация» (ТЗ 6.8): один компонент
 * на все типы `spec-*` (файл 08). Текст берётся готовым из параметров уведомления — его собирает
 * сервер (ТЗ 8.1), клиент не составляет фраз из кодов и не склоняет слова.
 *
 * Ссылка ведёт к объекту (ТЗ 6.8): дизайнеру — спецификация проекта с раскрытой позицией или чат
 * проекта; поставщику — карточка его запроса (при необходимости с позицией) или чат кабинета.
 * Поставщику проект и спецификация в параметрах не передаются (ТЗ 3.4, 8.1), поэтому именно по
 * наличию проекта в параметрах и различается адресат. Сгенерировано Claude.
 */
export default {
  name: 'NotificationSpecification',
  props: {
    item: Object,
    type: String,
  },
  computed: {
    info() { return this.item?.info ?? {}; },
    text() { return this.info.text ?? ''; },
    isChatMessage() { return this.item?.type === 'spec-chat-message'; },
    iconName() { return this.isChatMessage ? 'notification-comment' : 'notification-play'; },
    /** Адрес перехода «к объекту» (ТЗ 6.8, карта маршрутов 6.1). */
    route() {
      const { projectId, chatId, requestId, itemId } = this.info;

      if (!projectId) return this.supplierRoute(chatId, requestId, itemId);

      if (this.isChatMessage && chatId) {
        return { name: 'project-chat', params: { projectId, chatId: String(chatId) } };
      }

      return {
        name: 'project-specification',
        params: { projectId },
        query: itemId ? { item: String(itemId) } : {},
      };
    },
  },
  methods: {
    /** Кабинет поставщика: чат по идентификатору или карточка запроса с позицией (ТЗ 6.1, 6.5). */
    supplierRoute(chatId, requestId, itemId) {
      if (this.isChatMessage && chatId) {
        return { name: 'supplier-chat', params: { chatId: String(chatId) } };
      }
      if (!requestId) return null;
      return {
        name: 'supplier-request',
        params: { requestId: String(requestId) },
        query: itemId ? { item: String(itemId) } : {},
      };
    },
  },
};
</script>

<style scoped lang="scss">
</style>
